/*
 * Action types
 */
export const AUTHORIZE = '@@googleClassroom/AUTHORIZE'
export const AUTHORIZE_ERROR = '@@googleClassroom/AUTHORIZE_ERROR'
export const CONFIRM_AUTHORIZE = '@@googleClassroom/CONFIRM_AUTHORIZE'
export const CONFIRM_AUTHORIZE_ERROR =
  '@@googleClassroom/CONFIRM_AUTHORIZE_ERROR'
export const SIGN_IN = '@@googleClassroom/SIGN_IN'
export const SIGN_OUT = '@@googleClassroom/SIGN_OUT'

export const gapiDisconnectAction = () => async (dispatch) => {
  dispatch({
    type: SIGN_OUT,
  })
}

export const gapiErrorAction = (error, isErrorLink) => async (dispatch) => {
  dispatch(gapiDisconnectAction())
  dispatch({
    error,
    isErrorLink,
    type: AUTHORIZE_ERROR,
  })
}

export const gapiUserSignInAction = () => async (dispatch) => {
  dispatch({
    type: SIGN_IN,
  })
}

export const gapiAuthorizeAction = () => async (dispatch) => {
  dispatch({
    type: AUTHORIZE,
  })
}

export const gapiConfirmAuthorizeAction = () => async (dispatch) => {
  dispatch({
    type: CONFIRM_AUTHORIZE,
  })
}

export const gapiAcceptAuthorizeErrorAction = () => async (dispatch) => {
  dispatch({
    type: CONFIRM_AUTHORIZE_ERROR,
  })
}
